<template>
  <div class="app-header">
  </div>
</template>

<script>
export default {
  name: 'appHeader'
}
</script>

<style scoped lang="scss">
@import '../assets/_vars';

.app-header {
  background:$lightBlue;
  width:100%;
	height:64px;
	position:fixed;
	top:0; 
	z-index:10;
}
</style>



// WEBPACK FOOTER //
// src/components/appHeader.vue